import React from 'react';
import Layout from '~/components/layout/_layout';
import SEO from '~/components/seo';
import { Trans, withI18n } from '@lingui/react';
import { YellowButton, BlackTransparentButton } from '~/styles/buttons';
import styled from 'styled-components';
import getConfig from 'next/config';
const { publicRuntimeConfig } = getConfig();
import { t } from '@lingui/macro';

// todo: remove?
const SingIn = () => {
    return (
        <Layout>
            <SEO title={t`page.joinUs.seo.title`} description={t`page.joinUs.seo.description`} />
            <ContentWrapper>
                <Heading>
                    <Trans id="global.sign_in.heading" />
                </Heading>
                <Description>
                    <Trans id="global.sign_in.description" />
                </Description>
                <YellowButton href={publicRuntimeConfig.PAY_APP_URL}>
                    <Trans id="global.sign_in.cta.sign_in" />
                </YellowButton>
                <CustomBlackTransparentButton  href={publicRuntimeConfig.PAY_APP_URL}>
                    <Trans id="global.sign_in.cta.register" />
                </CustomBlackTransparentButton>
            </ContentWrapper>
        </Layout>
    );
};

export default withI18n()(SingIn);

const ContentWrapper = styled.div`
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    max-width: 276px;
    padding-top: 86px;
    padding-bottom: 160px;
`;

const Heading = styled.div`
    font-style: normal;
    font-weight: bold;
    font-size: 35px;
    line-height: 56px;
    letter-spacing: -0.25px;
    color: #0cc8a8;
    margin-bottom: 16px;
    text-align: center;
`;

const Description = styled.div`
    font-size: 16px;
    line-height: 22px;
    text-align: center;
    letter-spacing: 0.6px;
    color: #3c3b3b;
    margin-bottom: 24px;
`;

const CustomBlackTransparentButton = styled(BlackTransparentButton)`
    margin-top: 15px;
`;
